import { RECORDING_CONSENT_KEY } from '@telespot/shared/session-recorder';

import { ICookiesGroup } from '.';

export const cookiesData: ICookiesGroup[] = [
  {
    title: 'dialogs.cookies.essential.title',
    _type: 'essential',
    items: [],
    needed: true,
    description: 'dialogs.cookies.essential.description',
    collapsed: true,
  },
  {
    title: 'dialogs.cookies.performance.title',
    _type: 'performance',
    description: 'dialogs.cookies.performance.description',
    items: [
      {
        type: 'fullstory',
        title: 'dialogs.cookies.performance_fullstory.title',
        _key: RECORDING_CONSENT_KEY,
        default: true,
        group: 'analytics',
        description: 'dialogs.cookies.performance_fullstory.description',
      },
    ],
    collapsed: true,
  },
];
